import React from "react";
import FormText from "./form/formText.component";
import ContainerBox from "./common/containerBox.component";
import { useDispatch, useSelector } from "react-redux";
import { enterBankName } from "../actions/index";
import { stateProps } from "../types";
import FormSingleInput from "./form/formSingleInput.component";

const BankName: React.FC = () => {
  const dispatch = useDispatch();

  const bnkName = useSelector(
    (state: { router: History; doctorInfo: stateProps }) =>
      state.doctorInfo.bankName
  );

  const onInputChange = (event: any) => {
    const { value } = event.target;
    dispatch(enterBankName(value));
  };

  return (
    <React.Fragment>
      <ContainerBox>
        <FormText number={"15"} title={"Bank Name"} />
        <FormSingleInput
          value={bnkName}
          onInputChange={onInputChange}
          placeholder={"Bank name"}
        />
      </ContainerBox>
    </React.Fragment>
  );
};

export default BankName;
